export default function Footer() {
  return (
    <div className="relative z-10 w-full py-5 text-center bg-[#8B9A6E]">
      <p className="font-sans text-sm text-white m-0">
        Made with love by{' '}
        <a
          href="https://www.hunacreatives.com/contact"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white underline font-semibold"
        >
          The RSVP Studio
        </a>
      </p>
    </div>
  );
}
